import { useParams } from "react-router-dom";
import { useAppStore } from "../store/useAppStore";
import { ContextHeader } from "../components/layout/ContextHeader";
import { SituationPanel } from "../components/situations/SituationPanel";

export function SituationDetail() {
  const { situationId } = useParams();
  const situation = useAppStore((s) => s.situations.find((sit) => sit.id === situationId));
  const site = useAppStore((s) => s.sites.find((si) => si.id === situation?.siteId));
  const unit = useAppStore((s) => s.units.find((u) => u.id === situation?.unitId));

  if (!situation) return <p className="p-6 text-[13.5px] text-muted-foreground">Situation not found.</p>;

  return (
    <div className="flex flex-1 flex-col">
      <ContextHeader
        onBack
        crumb={`${site?.name.toUpperCase() ?? ""}${unit ? ` › ${unit.unitNumber}` : ""}`}
        title="Situation"
        subtitle={situation.category.replace(/-/g, " ")}
      />
      <div className="mx-auto w-full max-w-xl">
        <SituationPanel situation={situation} />
      </div>
    </div>
  );
}
